export default "__VITE_ASSET__PVgRlFEp__"